import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { FilterPipe, OrderByPipe } from '@wm/components-base';
import { BaseComponent, SearchComponent } from '@wms/components';
import { getClonedObject } from '@wms/core';
import { extend, isObject } from 'lodash-es';
import { BindTreeUtilsService, BindVariableService } from '@wms/services';
import {AppLocaleManagerService} from "@wms/i18n";
import {EventManagerService} from "@wms/app";

@Component({
  selector: 'wms-bind-localized-messages',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SearchComponent,
    TabsModule,
    OrderByPipe,
    FilterPipe
  ],
  templateUrl: './bind-localized-messages.component.html',
  styleUrls: ['./bind-localized-messages.component.less']
})
export class BindLocalizedMessagesComponent extends BaseComponent implements OnInit {
  messages: any = [];
  pageSearchKey: string;
  selectedMessage: any = {};
  supportedLocale: any;
  defaultLocale: any;
  selectedLocale: any;
  localeCodesMap: any = {};
  localeBundleSubscription: any;
  appMessagesSubscription: any;

  bindVariableService: BindVariableService;
  bindTreeService: BindTreeUtilsService;
  appLocaleManagerService: AppLocaleManagerService;


  constructor() {
    super();
    this.bindVariableService = inject(BindVariableService);
    this.bindTreeService = inject(BindTreeUtilsService);
    this.appLocaleManagerService = inject(AppLocaleManagerService);

    this.updateLocaleInfo();
    this.initAppMessages();
  }


  /* initialize the app messages tab */
  initAppMessages() {
    if (this.bindVariableService.appMessagesInitialized) {
      return;
    }
    this.bindVariableService.appMessagesInitialized = true;
    this.loadAppMessages(this.defaultLocale);
  }

  /* loadAppMessages based on selectedLocale */
  onLocaleChange(locale: any) {
    this.loadAppMessages(locale);
  }

  /* update the selected message and validate the binding */
  onMessageSelect(message: any) {
    this.selectedMessage.active = false;
    this.selectedMessage = message;
    message.active = true;
    this.bindVariableService.validateBinding(message, {
      "bindable": true,
      "value": message.key,
      "type": "message",
      "datatype": "string"
    });
  }

  /* this method will load the default locale bundle of the app */
  loadAppMessages(locale: any) {
    let localeBundle = this.i18nService.getAppLocaleBundle(locale),
      isActive: any,
      boundedMessage = this.bindTreeService.isBoundValue ? this.bindTreeService.boundEntityValue.replace(this.bindVariableService.appLocaleBindExpr + '.', '') : undefined,
      activeMessage: any,
      message: any,
      isPrevBound = this.bindTreeService.isPrevBoundValue;

    localeBundle = extend(getClonedObject(localeBundle.systemMessages) || {}, localeBundle.userMessages || {});

    if (isObject(localeBundle)) { // prepare the messages to display on the ui.
      this.messages = Object.keys(localeBundle).map((key: any) => {
        message = {
          "key": key,
          "value": (localeBundle as any)[key]
        };
        if (!activeMessage) {
          isActive = isPrevBound ? false : (key === boundedMessage);
          if (isActive) {
            activeMessage = message;
          }
        }
        return message;
      });

      if (activeMessage) {
        this.onMessageSelect(activeMessage);
      }
      /*If a entity is bound, Using timeout to delay till table is created on UI
       so that scroll to bound entity works on table*/
      setTimeout(() => {
        let activeLabelElements = document.getElementsByClassName('.active-label');
        if (activeLabelElements.length) {
          activeLabelElements[0].scrollIntoView();
        }
      }, undefined, false);
    }
  }

  filterPages(event: any) {
    this.pageSearchKey = event.searchKey;
  }

  /* Fetch default locale, supported locale values from I18nService and update*/
  updateLocaleInfo() {
    this.defaultLocale = this.i18nService.getAppDefaultLocale();
    this.selectedLocale = this.defaultLocale;
    this.supportedLocale = this.i18nService.getAppSupportedLocale();
  }

  ngOnInit(): void {
    import('src/assets/resources/files/localeCodesMap').then(response => {
      this.localeCodesMap = response.localeCodesMap;
    });
    this.localeBundleSubscription = this.i18nService.localeBundleSubject.subscribe((response: any) => {
      this.updateLocaleInfo();
      this.loadAppMessages(this.defaultLocale);
    });
    this.appMessagesSubscription = this.bindVariableService.appMessagesSubject.subscribe((response: any) => {
      this.initAppMessages();
    });

  }

  createNewLocaleMessage() {
    this.appLocaleManagerService.projectDefaultLanguage = this.projectService.getDetails().properties.defaultLanguage;
    this.appLocaleManagerService.projectDetails = this.projectService.getDetails();
    this.appLocaleManagerService.projectProps = this.appLocaleManagerService.projectDetails.properties;
    this.appLocaleManagerService.showNewLocaleMsgScreen = true;
    // this.appLocaleManagerService.toggleMessage(false);
    this.appLocaleManagerService.addInProgress = true;
    this.appLocaleManagerService.toggleMessage(true, this.locale.MESSAGE_LOADING, 'loading');
    this.appLocaleManagerService.initAppLocaleBundle()
    this.appLocaleManagerService.activeMessage = {};
    this.appLocaleManagerService.activeFormat = {};
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    if (this.localeBundleSubscription) {
      this.localeBundleSubscription.unsubscribe();
    }
    if (this.appMessagesSubscription) {
      this.appMessagesSubscription.unsubscribe();
    }
  }
}



